module.exports.UNPKG_CDN_URL = `https://unpkg.com/@popperjs/core@2`;
